import { Helmet } from "react-helmet-async";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Stats from "@/components/landing/Stats";
import Features from "@/components/landing/Features";
import HowItWorks from "@/components/landing/HowItWorks";
import Trust from "@/components/landing/Trust";
import Pricing from "@/components/landing/Pricing";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import LeadCapture from "@/components/landing/LeadCapture";

const FAQ_ITEMS = [
  {
    q: "$39 once — what's the catch? Is this really lifetime?",
    a: "No catch, no trial-to-subscription bait-and-switch. One payment of $39 unlocks the platform forever, including every new source, scoring update, and blueprint format we ship.",
  },
  {
    q: "Why so cheap when competitors charge $50–$200/month?",
    a: "Because we're not a research agency with account managers — we're a software product. The same automation that surfaces trends for you also lets us serve thousands of operators without scaling headcount.",
  },
  {
    q: "What exactly do I get for $39?",
    a: "Unlimited access to the live trend feed (refreshed daily across 35+ sources), the full blueprint for every trend (buyer profile, price band, 3 product angles, supplier or template list, competition snapshot, 7-day launch plan), the monthly hit-rate report, every future feature, and email support.",
  },
  {
    q: "Are there any upsells, add-ons, or hidden fees later?",
    a: "Zero. There's no Pro tier, no per-trend unlock, no 'export credits,' no API metering. Your $39 license keeps getting everything in the core product.",
  },
  {
    q: "What if it doesn't work for me?",
    a: "Use it for 14 days. If you don't surface at least one trend you'd genuinely build, email us and we refund the full $39 — no questions.",
  },
];


const Index = () => (
  <>
    <Helmet>
      <title>Trends Discovery — Spot Tomorrow's Best-Sellers Today</title>
      <meta name="description" content="AI scans 35+ underground sources in real-time to surface tomorrow's winning niches — and hands you the complete blueprint to launch them first." />
      <link rel="canonical" href="https://trendsdiscovery.com/" />
      <meta property="og:title" content="Trends Discovery — Spot Tomorrow's Best-Sellers Today" />
      <meta property="og:description" content="AI scans 35+ underground sources in real-time to surface tomorrow's winning niches — and hands you the complete blueprint to launch them first." />
      <meta property="og:url" content="https://trendsdiscovery.com/" />
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: FAQ_ITEMS.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      })}</script>
    </Helmet>
    <main className="min-h-screen bg-background text-foreground">
      <Nav />
      <Hero />
      <Stats />
      <Features />
      <HowItWorks />
      <Trust />
      <LeadCapture />
      <Pricing />
      <FAQ />
      <FinalCTA />
    </main>
  </>
);

export default Index;
